import React from "react";
import { Button } from "@mui/material";
import { LocationOn } from "@mui/icons-material";
import { useAppSelector } from "../../../../../store";
import { getFullMapsState } from "../../../../../store/slices/maps/maps.slice";

const MapButton = ({ canEdit, text }: { canEdit: boolean; text: string }) => {
	const { coordinates } = useAppSelector(getFullMapsState);
	const handleLocationClick = () => {
		if (!canEdit) {
			const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${coordinates.lat},${coordinates.lng}`;
			window.open(mapsUrl, "_blank");
		}
	};

	return (
		<Button
			variant={"contained"}
			startIcon={<LocationOn />}
			style={{ marginTop: "10px" }}
			onClick={handleLocationClick}
		>
			{text}
		</Button>
	);
};

export default MapButton;
